import React from "react";
import bgImage from "../../Images/bg-hook.png";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
const ACCENT = "#BEE262";
const NAVY = "#1A4564";

export default function Hook() {
  return (
    <section className="relative w-[90%] 2xl:w-[70%] mx-auto  mt-16">
      {/* Fixed-height hero (controls design stability) */}
      <div className="relative w-full min-h-[50vh] md:min-h-[90vh]">

        {/* BACKGROUND IMAGE – FIRMLY PLACED */}
        <img
          src={bgImage}
          alt="Hero background"
          className="absolute inset-0 w-full h-full object-contain  object-bottom md:object-center mt-12 md:mt-0"
        />

   

        {/* CONTENT LAYER */}
        <div className="relative z-10 h-full">
          <div className="max-w-7xl mx-auto px-6 h-full flex items-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 w-full">

              {/* LEFT CONTENT */}
              <div className="flex flex-col justify-center">
                <h1 className="h2-mb h2-md h2-lg h2-2xl">
                  Bereit für eine Webseite,
               
                  <span style={{ color: ACCENT }}>
                    die wirklich verkauft?
                  </span>
                </h1>

           

                <div className="mt-6 flex flex-wrap gap-3">
                                <Link
                                  to="/kontak"
                                  className="group inline-flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-black shadow transition hover:bg-white/90 border border-gray-500"
                                >
                                  Kontakt
                                  <ArrowRight
                                    size={16}
                                    className="transition group-hover:translate-x-0.5"
                                  />
                                </Link>
                
                                <Link
                                  to="/unverbindliches-angebot"
                                  className="inline-flex items-center rounded-xl border border-white/55 bg-[#0b2b40] px-5 py-2.5 text-sm font-semibold text-white/85 transition hover:bg-[#0b2b40]/90"
                                >
                                  Angebot einholen
                                </Link>
                              </div>
              </div>

              {/* RIGHT SPACE */}
              {/* IMPORTANT: we leave this empty because the card is PART of the background image */}
              <div className="hidden lg:block" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
